import { render, staticRenderFns } from "./Update_Work_WorkUnit.vue?vue&type=template&id=ecdd5e36"
import script from "./Update_Work_WorkUnit.vue?vue&type=script&lang=js"
export * from "./Update_Work_WorkUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports